import React from 'react'

import { Routes } from '@guiker/router'

const Router: React.FC = () => {
  return <Routes></Routes>
}

export { Router }
